import { render, staticRenderFns } from "./CourseCardMini.vue?vue&type=template&id=30432e12&"
import script from "./CourseCardMini.vue?vue&type=script&lang=js&"
export * from "./CourseCardMini.vue?vue&type=script&lang=js&"
import style0 from "./CourseCardMini.vue?vue&type=style&index=0&id=30432e12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports